export const ServiceData = {
    pt: [
        {
            "image": "/images/icon/icon-1.png",
            "title": "Mudanças Rápidas e Seguras",
            "description": "A FielCarga conta com uma equipa especializada para realizar a sua mudança com rapidez, segurança e profissionalismo. O orçamento é ajustado consoante os serviços necessários e pode ser solicitado diretamente através do formulário do nosso site ou pelo WhatsApp, de forma rápida e prática!"
        },
        {
            "image": "/images/icon/icon-2.png",
            "title": "Serviço Completo de Mudança",
            "description": "Disponibilizamos o veículo adequado à mercadoria, equipa em número ideal, embalamento, montagem e desmontagem, além da organização completa no destino."
        },
        {
            "image": "/images/icon/icon-3.png",
            "title": "Consciência Ambiental",
            "description": "Após a entrega, recolhemos todo o material de embalamento para reciclagem, porque levamos a consciência ambiental a sério! Entre em contacto connosco e peça já o seu orçamento personalizado!"
        }
    ],
    en: [
        {
            "image": "/images/icon/icon-1.png",
            "title": "Fast and Safe Moving",
            "description": "FielCarga has a specialized team to carry out your move with speed, safety and professionalism. The quote is adjusted according to the necessary services and can be requested directly through our website form or via WhatsApp, quickly and easily!"
        },
        {
            "image": "/images/icon/icon-2.png",
            "title": "Complete Moving Service",
            "description": "We provide the appropriate vehicle for the goods, ideal number of team members, packaging, assembly and disassembly, in addition to complete organization at the destination."
        },
        {
            "image": "/images/icon/icon-3.png",
            "title": "Environmental Awareness",
            "description": "After delivery, we collect all packaging material for recycling, because we take environmental awareness seriously! Contact us and request your personalized quote now!"
        }
    ]
};

